import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { BrandHeader } from './components/BrandHeader';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Solution } from './components/Solution';
import { QueAprenderas } from './components/QueAprenderas';
import { SistemaPorDentro } from './components/SistemaPorDentro';
import { Benefits } from './components/Benefits';
import { ConfianzaSistema } from './components/ConfianzaSistema';
import { TestimoniosSistema } from './components/TestimoniosSistema';
import { ComparacionSistema } from './components/ComparacionSistema';
import { PreguntasFrecuentes } from './components/PreguntasFrecuentes';
import { MasterFinalCTA } from './components/MasterFinalCTA';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1100702405600602');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1100702405600602&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-white font-sans text-brand-text selection:bg-brand-gold/30" data-id="element-0" data-mp="stkn01z26g1q">
      <TopBar data-id="element-1" data-mp="35ghusegjner" />
      <BrandHeader data-id="element-2" data-mp="34x31kk3tf4y" />
      <main data-id="element-3" data-mp="38kvshhq5xim">
        <Hero data-id="element-4" data-mp="3uct4hmy40t22" />
        <Identification data-id="element-5" data-mp="3ud1dv4v0xg8i" />
        <Solution data-id="element-6" data-mp="3ubrhql7qei4i" />
        <QueAprenderas data-id="element-7" data-mp="3uc9inv5c9kir" />
        <SistemaPorDentro data-id="element-8" data-mp="3uf5hrmsxaf8s" />
        <Benefits data-id="element-9" data-mp="d57hf8hvkslp" />
        <ConfianzaSistema data-id="element-10" data-mp="d3mkjc838xko" />
        <TestimoniosSistema data-id="element-11" data-mp="d3wch5cp1et0" />
        <ComparacionSistema data-id="element-12" data-mp="85l30vqb96bb" />
        <PreguntasFrecuentes data-id="element-13" data-mp="85bdf996h165" />
        <MasterFinalCTA data-id="element-14" data-mp="86499f6lm69i" />
      </main>
      <Footer data-id="element-15" data-mp="3gle90gn0mze4" />
      <StickyBuyBar data-id="element-16" data-mp="3gkv0fqj99ncr" />
    </div>;
}